
import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { GoogleAuth } from './GoogleAuth';
import { useSupabase } from '@/hooks/useSupabase';
import { useToast } from '@/hooks/use-toast';

interface AuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAuth: (user: any) => void;
  isDarkMode: boolean;
}

export const AuthModal = ({ isOpen, onClose, onAuth, isDarkMode }: AuthModalProps) => {
  const [step, setStep] = useState<'auth'>('auth');
  const [isLoading, setIsLoading] = useState(false);
  
  const { signInWithGoogle } = useSupabase();
  const { toast } = useToast();

  // Captcha removed

  const handleGoogleAuth = async () => {
    try {
      setIsLoading(true);
      const { error } = await signInWithGoogle();
      
      if (error) {
        toast({
          title: "Error",
          description: error.message,
          variant: "destructive"
        });
      }
    } catch (error) {
      console.error('Google auth error:', error);
      toast({
        title: "Error",
        description: "Failed to sign in with Google",
        variant: "destructive"
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className={`sm:max-w-md max-w-[320px] px-0 xs:px-4 rounded-xl ${
        isDarkMode 
          ? 'bg-[#1E1E1E] border-gray-700 text-white' 
          : 'bg-white border-gray-200 text-gray-900'
      }`}>
        {step === 'auth' && (
          <>
            <DialogHeader>
              <DialogTitle className="text-center text-xl">
                Sign in with Google
              </DialogTitle>
              <DialogDescription className="sr-only">Authenticate to access unlimited features and save your data.</DialogDescription>
            </DialogHeader>
            
            <div className="flex items-center justify-center flex-col space-y-4">
              <GoogleAuth onAuth={handleGoogleAuth} isDarkMode={isDarkMode} isLoading={isLoading} />
              
              <div className="text-center">
                <p className={`text-sm ${
                  isDarkMode ? 'text-gray-400' : 'text-gray-600'
                }`}>
                  Sign in with Google to access unlimited features and save your data
                </p>
              </div>
            </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};
